import { useState } from 'react'
import {Select, Modal, Switch, Form, TreeSelect, Cascader, message} from 'antd'
import {httpOrgList} from "@/services/homeService.ts";
import {useSetState} from "ahooks";
import { STitle, SDrawerOrModal, SLocalTreeSelected } from 'shj-components'
import DebounceSearchSelect from "@/pages/baseProduct/components/DebounceSearchSelect";
import {findBuildingPage} from "@/services/customerServices.ts";
import {useEffect} from "react";
import {getChildrenDicts} from "@/services";
import {goodsManagementGoodsSkuSave, getGoodsSaleCategoryTreeList, getCategoryByParentId} from "@/services/goods.ts";
import { getHouseTypeEnum } from '@/services/customerServices';

const ArriveModal = props => {
  const {open, onClose, isMultiple, idList, fn, record} = props
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [state, setState] = useSetState({
    companyList: [],
    buildTypeList: [],
    categoryTree: [],
    saleTree: [],
    onSelf: true,
  })

  const onSelf = Form.useWatch('onSelf', form);

  useEffect(() => {
    getOptions()
  }, []);

  useEffect(() => {
    setState({onSelf: true})
    form.resetFields()
    form.setFieldsValue({onSelf: true})
    if (record) {
      const {buildingJsonList, houseTypeJsonList, shopJsonList} = record.channelJson || {}
      form.setFieldsValue({
        orgIdList: shopJsonList?.map(item => item.id),
        buildInfoIdList: buildingJsonList?.map(item => item.id),
        houseTypeCodeList: houseTypeJsonList?.map(item => item.code),
        saleCatId: record.saleCatId,
        memberCatId: record.memberCatId,
      })
    }
  }, [open]);

  const getOptions = async () => {
    const categoryTree = await getGoodsSaleCategoryTreeList({ enabled: true })
    const companyList = await httpOrgList();
    const buildType = await getHouseTypeEnum();
    const saleTree = await getCategoryByParentId(0);
    setState({companyList, buildTypeList: buildType || [], categoryTree, saleTree})
  }
  const save = () => {
    form.validateFields().then((values) => {
      console.log(values)
      if (isMultiple) {
        if ((!values.memberCatId && !values.saleCatId) && values.onSelf) {
          message.info('成交王或C端小程序销售类目至少选择一个');
          return;
        }
      } else {
        if (!values.memberCatId && !values.saleCatId) {
          message.info('成交王或C端小程序销售类目至少选择一个');
          return;
        }
      }
      console.log(isMultiple, values.onSelf)
      const newValues = {...values, idList, onSelf: isMultiple ? values.onSelf : true}
      setLoading(true)
      goodsManagementGoodsSkuSave(newValues).then(res => {
        message.success(res.message || '操作成功');
        onClose()
        fn()
        setLoading(false)
      }).catch((err) => { setLoading(false)})
    });
  }

  return (
      <SDrawerOrModal
          mode="drawer"
          open={open}
          onCancel={onClose}
          loading={loading}
          width={600}
          title={isMultiple ? "批量上架设置" : "上架设置"}
          onOk={save}
      >
        <Form
            style={{padding: "10px 10px 0 10px"}}
            form={form}
            layout={'vertical'}
            initialValues={{onSelf: state.onSelf}}
            name="paySetInfo"
        >
            <STitle title={'上架门店'} />
            {
                isMultiple && (
                    <Form.Item
                        name="onSelf"
                        label="是否上架"
                        rules={[
                          {
                            required: true,
                            message: '请选择是否上架',
                          },
                        ]}
                        style={{ marginTop: 10 }}
                        valuePropName='checked'
                        initialValue={true}
                    >
                      <Switch checkedChildren="是" unCheckedChildren="否" onChange={v => setState({onSelf: v})}/>
                    </Form.Item>
                )
            }
            {
                state.onSelf && <>
                  <Form.Item
                      name="orgIdList"
                      label="上架门店"
                      rules={[
                        {
                          required: true,
                          message: '请选择上架门店',
                        },
                      ]}
                  >
                    <Select optionFilterProp={'name'} mode={'multiple'} placeholder={'请选择上架门店'}
                            options={state.companyList} fieldNames={{label: 'name', value: 'id'}} maxTagCount={3}/>
                  </Form.Item>
                  <Form.Item
                      name="buildInfoIdList"
                      label="关联楼盘"
                  >
                    <DebounceSearchSelect label={'关联楼盘'} nameKey={'nameLike'} mode={"multiple"}
                                          fetchOptions={findBuildingPage} maxTagCount={3}/>
                  </Form.Item>
                  <Form.Item
                      name="houseTypeCodeList"
                      label="关联户型"
                  >
                    <Select placeholder={'请选择关联户型'} options={state.buildTypeList} mode={'multiple'}
                            optionFilterProp={'description'} fieldNames={{label: 'description', value: 'key'}} maxTagCount={5}/>
                  </Form.Item>
                  <STitle title={'上架销售类目'} />
                  <Form.Item
                      name="saleCatId"
                      label="成交王店铺"
                      style={{ marginTop: 10 }}
                  >
                    <TreeSelect
                      allowClear
                      treeData={state.categoryTree}
                      fieldNames={{ value: 'id' }}
                      placeholder={'请选择成交王店铺'}
                      />
                  </Form.Item>
                  <Form.Item
                      name="memberCatId"
                      label="C端小程序"
                  >
                    <TreeSelect
                      allowClear
                      treeData={state.saleTree}
                      fieldNames={{ value: 'id' }}
                      placeholder={'请选择C端小程序销售类目'}
                    />
                  </Form.Item>
                </>
            }
        </Form>
      </SDrawerOrModal>
  )
}

export default ArriveModal
